import { RouteConfig } from "vue-router";

import { HomeRoute } from "./Home";
import { UserRoute } from "./User";

export const AdminRoute: Array<RouteConfig> = [...HomeRoute, ...UserRoute];
